import React from 'react';
import PropTypes from 'prop-types';

export default class YourInfo extends React.Component {
	static propTypes = {
		data: PropTypes.object,
		onChange: PropTypes.func,
		onNextPage: PropTypes.func,
		parent: PropTypes.object,
	};

	constructor( props ) { 
		super( props );

		this.state = {
			tested: {},
			nextPageCheck: false, 
			showELink: false
		};

		this.fields = [ 'fname', 'lname', 'username', 'email', 'password', 'password_confirm' ];
	}
	
	remoteTestItem( id, val ) {
		jQuery.ajax( {
			method: "POST",
			url: window.dt_js_details.ajax_url,
			data: { action: 'dt_signup_test_item', id: id, value: val, classnum: this.props.data['classnum'] }
		} )
			.done( msg => {
				var tested = this.state.tested;
				tested[ id ] = { 
					status: msg.status, 
					err: msg.err, 
					issue_code: msg.issue_code, 
					verified: msg.verified, 
					extra: { curval: val }, 
					running: false };
				this.setState( { tested } );
			} )
			.fail( err => {
				window.alert( "Issue connecting to server to test item", err );
			} );
	}

	testField( id ) { 
		var tested = this.state.tested;
		var val = this.props.data[ id ];

		if( !val || val === '' ) { 
			tested[ id ] = { status: false, err: 'You must enter a value for this field', running: false, extra: { curval: '' } };
			this.setState( { tested } ); 
		} else {
			if( id !== 'password_confirm' && tested[id] && val === tested[id].extra.curval ) { 
				this.setState( { tested } ); 
			} else { 
				if( id === 'password_confirm' ) { 
					if( this.props.data['password'] !== val ) { 
						tested[ id ] = { status: false, err: 'Your Passwords Must Match', extra: { curval: val }, running: false };
						this.setState( { tested } ); 
					} else { 
						tested[ id ] = { status: true, err: '', extra: { curval: val }, running: false };
						this.setState( { tested } ); 
					}
				}
				if( id === 'username' ) { 
					tested[ id ] = { status: false, running: true, err: '', extra: { curval: '' } };
					this.setState( { tested } ); 
					this.remoteTestItem( 'username', val );
				}
				if( id === 'email' ) { 
					tested[ id ] = { status: false, running: true, err: '', extra: { curval: '' } };
					this.setState( { tested } ); 
					this.remoteTestItem( 'email', val );
				}
				if( id === 'password' ) { 
					tested[ id ] = { status: false, running: true, err: '', extra: { curval: '' } };
					this.setState( { tested } ); 
					this.remoteTestItem( 'password', val );
				}
				if( id === 'fname' || id === 'lname' ) { 
					tested[ id ] = { status: true, running: false, err: '', extra: { curval: val } };
					this.setState( { tested } ); 
				}
			}
		}
	}

	onChange( id, val ) { 
		this.props.onChange( id, val );
	}

	onNextPage() { 
		for( var i = 0; i < this.fields.length; i ++ ) { 
			this.testField( this.fields[ i ] );
		}

		this.setState( { nextPageCheck: true } );
		this.checkctr = 0;
		window.setTimeout( () => { this.checkNextPage(); }, 100 );
	}

	checkNextPage() { 
		var fail = false;
		var done = true;

		for( var i = 0; i < this.fields.length; i ++ ) { 
			if( this.state.tested[ this.fields[ i ] ] && 
				! this.state.tested[ this.fields[ i ] ].status && 
				! this.state.tested[ this.fields[ i ] ].running ) { 
				fail = true;
			}

			if( ! this.state.tested[ this.fields[ i ] ] ||  
				this.state.tested[ this.fields[ i ] ].running ) { 
				done = false;
			}
		}

		if( fail === true ) { 
			window.alert( 'There are errors on your information, please fix it and try again' );
			this.setState( { nextPageCheck: false } );
		} else { 
			if( done ) { 
				this.props.onNextPage(); 
				this.setState( { nextPageCheck: false } );
			} else {
				this.checkctr ++;
				if( this.checkctr > 20 ) { 
					window.alert( 'The fields failed to test correctly.   Please check your internet connection and try again' );
					this.setState( { nextPageCheck: false } );
				} else { 
					window.setTimeout( () => { this.checkNextPage(); }, 100 );
				}
			}
		}
	}

	render() {
		return ( <div className="yourinfo_container">
				
			<div className="input_item">
				<input type="text" value={ this.props.data['fname'] ? this.props.data['fname'] : '' } 
					onBlur={ () => { this.testField( 'fname' ); } } 
					onChange={ e => { this.onChange( 'fname', e.target.value );}} 
				/>
				<label>First Name</label>
				{ this.state.tested['fname'] && ! this.state.tested['fname'].status ? 
					<div className="error">{ this.state.tested['fname'].err }</div> : '' }
			</div>
			<div className="input_item">
				<input type="text" value={ this.props.data['lname'] ? this.props.data['lname'] : '' } 
					onBlur={ () => { this.testField( 'lname' ); } } 
					onChange={ e => { this.onChange( 'lname', e.target.value );}} 
				/>
				<label>Last Name</label>
				{ this.state.tested['lname'] && ! this.state.tested['lname'].status ? 
					<div className="error">{ this.state.tested['lname'].err }</div> : '' }
			</div>
			<div className="input_item">
				<input type="text" value={ this.props.data['username'] ? this.props.data['username'] : '' } 
					onBlur={ () => { this.testField( 'username' ); } } 
					onChange={ e => { this.onChange( 'username', e.target.value );}} 
				/>
				<label>User Name</label>
				{ this.state.tested['username'] && ! this.state.tested['username'].status ? 
					<div className="error">{ this.state.tested['username'].err }</div> : '' }
				{ this.state.tested['username'] && this.state.tested['username'].running ? 
					<div className="error">Testing...</div> : '' }
			</div>
			<div className="input_item">
				<input type="text" value={ this.props.data['email'] ? this.props.data['email'] : '' } 
					onBlur={ () => { this.testField( 'email' ); } } 
					onChange={ e => { this.onChange( 'email', e.target.value );}} 
				/>
				<label>Email Address</label>
				{ this.state.tested['email'] && ! this.state.tested['email'].status ? 
					<div className="error">
						{ this.state.tested['email'].err }
						{ this.state.tested['email'].issue_code ? 
							<a style={{ margin: '3px' }} className="fas fa-question-circle" 
								onClick={ () => { this.setState( { showELink: true } ); }}></a> : '' }
					</div> : '' }
				{ this.state.tested['email'] && this.state.tested['email'].running ? 
					<div className="error">Testing...</div> : '' }
			</div>
			<div className="input_item">
				<input type="password" value={ this.props.data['password'] ? this.props.data['password'] : '' } 
					onBlur={ () => { this.testField( 'password' ); } } 
					onChange={ e => { this.onChange( 'password', e.target.value );}} 
				/>
				<label>Password</label>
				{ this.state.tested['password'] && ! this.state.tested['password'].status ? 
					<div className="error">{ this.state.tested['password'].err }</div> : '' }
				{ this.state.tested['password'] && this.state.tested['password'].running ? 
					<div className="error">Testing...</div> : '' }
			</div>
			<div className="input_item">
				<input type="password" value={ this.props.data['password_confirm'] ? this.props.data['password_confirm'] : '' } 
					onBlur={ () => { this.testField( 'password_confirm' ); } } 
					onChange={ e => { this.onChange( 'password_confirm', e.target.value );}} 
				/>
				<label>Confirm Password</label>
				{ this.state.tested['password_confirm'] && ! this.state.tested['password_confirm'].status ? 
					<div className="error">{ this.state.tested['password_confirm'].err }</div> : '' }
			</div>
				
			<div className="button_container">
				<input type="button" value="Next" onClick={ () => { this.onNextPage(); }} />
			</div>


			<div className="instruction_overlay" style={ { display: this.state.showELink ? 'block' : 'none' } } >
				<a className="fas fa-times" onClick={ () => { this.setState( { showELink: false } );  } }></a>
				<strong>User Exists</strong>
				<p>The system found your email address already connected with a user.  This means, you have 
					signed up for an account already.</p>
				{ this.state.tested['email'] && this.state.tested['email'].verified ? 
					<p>Your user has already been verified.  If you have forgotten your password, you can click <a target="_new" href="/wp-login.php?action=lostpassword"> Here </a> to reset your password</p> :
					<p>Your user has not been verified.  If you didn&apos;t recieve the verification email, you can click 
						<a onClick={ () => { this.props.parent.resendVerify(); } } > Here </a> 
							to resend the verification email
					</p>
				}
			</div>
		</div>
		);
	}
}